import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// vue-i18n 语言包
import VueI18N from 'vue-i18n'

Vue.use(VueI18N)
Vue.use(ElementUI)

Vue.config.productionTip = false

// 语言包的使用
const i18n = new VueI18N({
  locale: 'zh', // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: require('./common/lang/zh'), // 中文语言包
    en: require('./common/lang/en') // 英文语言包
  }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  // console.log(to.meta.content)
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')
    const meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next()
})

new Vue({
  router,
  store,
  i18n, // 挂载到实例，一定得在这个位置，而不是comonents中
  render: h => h(App)
}).$mount('#app')
